import React from "react";

const RefreshCCW = ({ width, height, color }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color || "#000000"}
      d="M8.54661 20.3288C10.9457 21.3931 13.8032 21.3353 16.2502 19.9226C20.3157 17.5754 21.7086 12.3768 19.3614 8.31136L19.1114 7.87834M4.63851 16.8115C2.2913 12.746 3.68424 7.54747 7.74972 5.20026C10.1967 3.78749 13.0542 3.72969 15.4533 4.79405M2.49341 16.8951L5.22546 17.6272L5.95751 14.8951M18.0426 10.2272L18.7747 7.49513L21.5067 8.22718"
    />
  </svg>
);

export default RefreshCCW;
